import { useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./megaMenu.gql";
import { useSelector } from "react-redux";

export const useMegaMenu = () => {
  const { getMegaMenuQuery, getCategoryQuery } = DEFAULT_OPERATIONS;
  const { ConfigData } = useSelector((state) => state.homePageSlice);
  const { megaMenu } = useSelector((state) => state.megaMenuSlice);

  const ids = ConfigData?.home_categories?.split(",").map((id) => id.trim());

  const { data: MegaMenuData, loading: megaMenuLoading } = useQuery(
    getMegaMenuQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      context: { fetchOptions: { method: "GET" } },
    }
  );

  const { data: categoryData, loading: categoryLoading } = useQuery(
    getCategoryQuery,
    {
      variables: { ids },
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      skip: !ids || ids.length === 0 || !megaMenu,
      context: { fetchOptions: { method: "GET" } },
    }
  );

  return {
    MegaMenuData,
    megaMenuLoading,
    categoryData,
    categoryLoading,
  };
};
